import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Link, useParams, useHistory } from "react-router-dom";
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import humburger from "../../assets/images/humburger.png";
import uploadDoc from "../../assets/images/upload-doc.png";
import { emailSuggestion, getQuestioner, SendQuestionnaire, getVendorServiceProfiles } from "../../actions/riskManagement";
import makeAnimated from 'react-select/animated';
import Select from 'react-select';
import { fetchCustomersforestView } from "../../actions/customer";
import { toastr } from 'react-redux-toastr';

const animatedComponents = makeAnimated();

const SendQuestionnaires = () => {
    const { orgId, templateId } = useParams();
    const history = useHistory();
    const dispatch = useDispatch();
    const id = useSelector((state) => orgId || state?.summary?.localClient?._id || state?.summary?.clients?.[0]?._id);
    const [isModal, setModal] = useState("");
    const [selectedTemplates, setSelectedTemplates] = useState([]);
    const templatesData = useSelector((state) => state?.riskManagement?.response);
    const emailData = useSelector((state) => state?.riskManagement?.emailSuggestion);
    const [isModalData, setModalData] = useState([]);
    const [thirdPartyOrganisationId, setThirdPartyOrganisationId] = useState("");
    const [emails, setEmails] = useState([]);
    const [emailQuery, setEmailQuery] = useState([]);
    const [thirdPartyOrganisationIdEmail, setThirdPartyOrganisationIdEmail] = useState([]);
    const [dueDate, setDueDate] = useState("");
    const [confirm, setConfirm] = useState(false);
    const [serviceProfiles, setServiceProfiles] = useState([]);
    const [selectedServiceProfile, setSelectedServiceProfile] = useState(null);
    // Adjust this value to change the limit for fetching customers
    const CUSTOMERS_FETCH_LIMIT = 100;
    let customers = useSelector(
        (state) => state?.customer?.forestlist?.data?.forestViewClients
    );
    const serviceProfilesData = useSelector((state) => state?.riskManagement?.vendorServiceProfiles?.data?.serviceProfiles);
    useEffect(() => {
        if (id) {
            getQuestioner(id, dispatch, false, '', 1);
        }
    }, [id])

    useEffect(() => {
        if (templateId && templatesData?.data) {
            // Pre-select the template if it exists in the templates data
            const templateExists = templatesData.data.some(template => template._id === templateId);
            if (templateExists) {
                setSelectedTemplates([templateId]);
            }
        }
    }, [templateId, templatesData?.data])

    useEffect(() => {
        if (id) {
            emailSuggestion(id, dispatch, thirdPartyOrganisationIdEmail, emailQuery)
        }
    }, [id, thirdPartyOrganisationIdEmail, emailQuery])


    useEffect(() => {
        if (id) {
            fetchCustomersforestView(id, dispatch, 1, '', '', '', '', '', CUSTOMERS_FETCH_LIMIT);
        }
    }, [id, CUSTOMERS_FETCH_LIMIT]);


    const modalClick = (data) => {
        setModalData(data)
        setModal("Form Wizard modal");
    }

    const storeSelectedTemplates = (templateId, isChecked) => {
        if (isChecked) {
            setSelectedTemplates([...selectedTemplates, templateId]);
        } else {
            const indexToRemove = selectedTemplates.indexOf(templateId);
            if (indexToRemove !== -1) {
                setSelectedTemplates(selectedTemplates.filter((_, index) => index !== indexToRemove));
            }
        }
    }

    const options = customers?.map((item) => (
        {
            value: item?._id,
            label: item?.orgName
        }
    ));


    const emailOption = emailData?.data?.map((item) => (
        {
            value: item,
            label: item
        }
    ));


    const handleChange = (selected) => {
        setThirdPartyOrganisationId(selected);
        setThirdPartyOrganisationIdEmail(selected?.value);
        setSelectedServiceProfile(null);
        
        if (selected?.value) {
            getVendorServiceProfiles(selected.value, dispatch);
        }
    };

    const handleChangeEmail = (selected) => {
        if (!selected) {
            setEmailQuery('');
            return;
        }

        // Validate email format
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        const emailToAdd = selected.value || selected;

        if (!emailRegex.test(emailToAdd)) {
            toastr.error("Error", "Please enter a valid email address");
            return;
        }

        // Check for duplicate email
        if (emails.includes(emailToAdd)) {
            toastr.error("Error", "This email has already been added");
            return;
        }

        setEmails([...emails, emailToAdd]);
        setEmailQuery('');
    };

    const handleRouteChange = () => {
        history.push('/tprm/questionnaires');
    };

    const removeEmail = (index) => {
        setEmails(emails.filter((_, i) => i !== index));
    }

    const addEmail = () => {
        if (!emailQuery || !emailQuery[0]) {
            toastr.error("Error", "Please enter an email address");
            return;
        }

        handleChangeEmail(emailQuery[0]);
    }


    const clearPage = () => {
        setEmails([]);
        setThirdPartyOrganisationId('');
        setDueDate('');
        setSelectedServiceProfile(null);
    }

    const sendButton = () => {
        if (selectedTemplates.length == 0) {
            toastr.error("Error", "Select At Least One Template to send");
            return
        }
        if (thirdPartyOrganisationId == "") {
            toastr.error("Error", "Select Company Name");
            return
        }
       
        if (dueDate == "") {
            toastr.error("Error", "Enter Due Date");
            return
        }
        if (emails == "") {
            toastr.error("Error", "Email is Required");
            return
        }
        if (confirm == false) {
            toastr.error("Error", "Read the terms & condition");
            return
        }
        let data = {
            questionerFormIds: selectedTemplates,
            emails: emails,
            thirdPartyOrganisationId: thirdPartyOrganisationId?.value,
            serviceProfileId: selectedServiceProfile?.value,
            dueDate
        }
        SendQuestionnaire(id, data, handleRouteChange)
    }

    // Watch for serviceProfiles changes to log them
    useEffect(() => {
        if (serviceProfilesData) {
            setServiceProfiles(serviceProfilesData);
        }
    }, [serviceProfilesData]);

    const serviceProfileOptions = serviceProfiles?.map(profile => ({
        value: profile._id,
        label: `${profile.name}-${profile.region}`
    }));

    const handleServiceProfileChange = (selected) => {
        setSelectedServiceProfile(selected);
    };

    return (
        <div className="container-fluid risk-dashboard">
            <div className="block-header">
                <div className="row clearfix">
                    <div className="col-md-6 col-sm-12">
                       <h1 className="welcome-text">Third Party Risk Management</h1>
                        <nav aria-label="breadcrumb" className="mt-1">
                        <ol className="breadcrumb">
                                <li className="breadcrumb-item">
                                    <Link to="/vendor" className="welcome-textSmall">
                                        Third Party Risk Management
                                    </Link>
                                    &nbsp;/&nbsp;
                                    <Link to="/tprm/questionnaires" className="welcome-textSmall">
                                        Manage Questionnaires
                                    </Link>
                                    &nbsp;/&nbsp;Send Questionnaires
                                </li>
                            </ol>
                        </nav>
                    </div>
                </div>
            </div>
            <div className="card">
                <div className="body" style={{height:"100vh"}}>
                    <div className="row">
                        <div className="col-md-8">
                            <div className="group-box">
                                <h6>Final step to send</h6>
                                <p>Decide whether to send the templates to a Vendor. Set the recipient, send and due dates, and add a reminder or message. Click 'Send' to complete the process.</p>
                                <p className="mb-3" style={{ fontSize: "12px" }}>Please select the appropriate company or vendor, customize the relevant details, and include any additional information if necessary before proceeding.</p>

                                <div className="mb-3 selectBox">
                                    <label className="form-label mb-1" style={{ fontWeight: 300 }}>Company name</label>
                                    <Select
                                        components={animatedComponents}
                                        options={options}
                                        value={options?.find(option => option.value === thirdPartyOrganisationId)}
                                        onChange={(selectedOption) => {
                                            handleChange(selectedOption);
                                        }}
                                        placeholder="Select Company Name"
                                        theme={(theme) => ({
                                            ...theme,
                                            colors: {
                                                ...theme.colors,
                                                primary: '#08283f',
                                                primary25: '#2c2c2c',
                                                primary50: '#353535',
                                                neutral0: '#dadada',
                                                neutral10: '#f0f0f0',
                                                neutral20: '#d0d0d0',
                                                neutral30: '#b3b3b3',
                                                neutral40: '#cccccc',
                                                neutral50: '#9e9e9e',
                                                neutral60: '#b3b3b3',
                                                neutral70: '#cccccc',
                                                neutral80: '#e6e6e6',
                                                neutral90: '#f2f2f2'
                                            }
                                        })}
                                        styles={{
                                            control: (base) => ({
                                                ...base,
                                                background: 'white',
                                                borderColor: '#d0d0d0',
                                                boxShadow: 'none',
                                                '&:hover': {
                                                    borderColor: '#08283f'
                                                }
                                            }),
                                            menu: (base) => ({
                                                ...base,
                                                background: 'white',
                                                border: '1px solid #d0d0d0',
                                                boxShadow: '0 4px 8px rgba(0, 0, 0, 0.2)',
                                                zIndex: 100
                                            }),
                                            option: (base, state) => ({
                                                ...base,
                                                background: state.isSelected ? '#08283f' : state.isFocused ? '#f5f5f5' : 'white',
                                                color: state.isSelected ? 'white' : '#333333',
                                                '&:hover': {
                                                    background: state.isSelected ? '#08283f' : '#f5f5f5'
                                                }
                                            }),
                                            multiValue: (base) => ({
                                                ...base,
                                                background: '#f0f0f0',
                                                border: '1px solid #d0d0d0'
                                            }),
                                            multiValueLabel: (base) => ({
                                                ...base,
                                                color: '#333333'
                                            }),
                                            multiValueRemove: (base) => ({
                                                ...base,
                                                color: '#9e9e9e',
                                                '&:hover': {
                                                    background: '#08283f',
                                                    color: 'white'
                                                }
                                            }),
                                            input: (base) => ({
                                                ...base,
                                                color: '#333333'
                                            }),
                                            placeholder: (base) => ({
                                                ...base,
                                                color: '#666666'
                                            }),
                                            singleValue: (base) => ({
                                                ...base,
                                                color: '#333333'
                                            })
                                        }}
                                    />
                                </div>

                                {id !== "68822dd70f4ca2fcbed92a3a" && (
                                <div className="mb-3 selectBox">
                                    <label className="form-label mb-1" style={{ fontWeight: 300 }}>Service Profile</label>
                                    <Select
                                        components={animatedComponents}
                                        options={serviceProfileOptions}
                                        value={selectedServiceProfile}
                                        onChange={handleServiceProfileChange}
                                        placeholder="Select Service Profile"
                                        isDisabled={!thirdPartyOrganisationId}
                                        theme={(theme) => ({
                                            ...theme,
                                            colors: {
                                                ...theme.colors,
                                                primary: '#08283f',
                                                primary25: '#2c2c2c',
                                                primary50: '#353535',
                                                neutral0: '#dadada',
                                                neutral10: '#f0f0f0',
                                                neutral20: '#d0d0d0',
                                                neutral30: '#b3b3b3',
                                                neutral40: '#cccccc',
                                                neutral50: '#9e9e9e',
                                                neutral60: '#b3b3b3',
                                                neutral70: '#cccccc',
                                                neutral80: '#e6e6e6',
                                                neutral90: '#f2f2f2'
                                            }
                                        })}
                                        styles={{
                                            control: (base) => ({
                                                ...base,
                                                background: 'white',
                                                borderColor: '#d0d0d0',
                                                boxShadow: 'none',
                                                '&:hover': {
                                                    borderColor: '#08283f'
                                                }
                                            }),
                                            menu: (base) => ({
                                                ...base,
                                                background: 'white',
                                                border: '1px solid #d0d0d0',
                                                boxShadow: '0 4px 8px rgba(0, 0, 0, 0.2)',
                                                zIndex: 100
                                            }),
                                            option: (base, state) => ({
                                                ...base,
                                                background: state.isSelected ? '#08283f' : state.isFocused ? '#f5f5f5' : 'white',
                                                color: state.isSelected ? 'white' : '#333333',
                                                '&:hover': {
                                                    background: state.isSelected ? '#08283f' : '#f5f5f5'
                                                }
                                            }),
                                            multiValue: (base) => ({
                                                ...base,
                                                background: '#f0f0f0',
                                                border: '1px solid #d0d0d0'
                                            }),
                                            multiValueLabel: (base) => ({
                                                ...base,
                                                color: '#333333'
                                            }),
                                            multiValueRemove: (base) => ({
                                                ...base,
                                                color: '#9e9e9e',
                                                '&:hover': {
                                                    background: '#08283f',
                                                    color: 'white'
                                                }
                                            }),
                                            input: (base) => ({
                                                ...base,
                                                color: '#333333'
                                            }),
                                            placeholder: (base) => ({
                                                ...base,
                                                color: '#666666'
                                            }),
                                            singleValue: (base) => ({
                                                ...base,
                                                color: '#333333'
                                            })
                                        }}
                                    />
                                </div>
                                )}

                                <div className="row mb-3 g-3">
                                    <div className="col-md-12">
                                        <label className="form-label mb-1" style={{ fontWeight: 300 }}>Email</label>
                                        <div className="d-flex selectBox">
                                            <div className="flex-grow-1">
                                                <Select
                                                    components={animatedComponents}
                                                    options={emailOption}
                                                    value={emailQuery}
                                                    onChange={handleChangeEmail}
                                                    onInputChange={(inputValue) => {
                                                        if (inputValue !== "") {
                                                            setEmailQuery([inputValue])
                                                        }
                                                    }}
                                                    placeholder="Select Email"
                                                    theme={(theme) => ({
                                                        ...theme,
                                                        colors: {
                                                            ...theme.colors,
                                                            primary: '#08283f',
                                                            primary25: '#2c2c2c',
                                                            primary50: '#353535',
                                                            neutral0: '#dadada',
                                                            neutral10: '#f0f0f0',
                                                            neutral20: '#d0d0d0',
                                                            neutral30: '#b3b3b3',
                                                            neutral40: '#cccccc',
                                                            neutral50: '#9e9e9e',
                                                            neutral60: '#b3b3b3',
                                                            neutral70: '#cccccc',
                                                            neutral80: '#e6e6e6',
                                                            neutral90: '#f2f2f2'
                                                        }
                                                    })}
                                                    styles={{
                                                        control: (base) => ({
                                                            ...base,
                                                            background: 'white',
                                                            borderColor: '#d0d0d0',
                                                            boxShadow: 'none',
                                                            '&:hover': {
                                                                borderColor: '#08283f'
                                                            }
                                                        }),
                                                        menu: (base) => ({
                                                            ...base,
                                                            background: 'white',
                                                            border: '1px solid #d0d0d0',
                                                            boxShadow: '0 4px 8px rgba(0, 0, 0, 0.2)',
                                                            zIndex: 100
                                                        }),
                                                        option: (base, state) => ({
                                                            ...base,
                                                            background: state.isSelected ? '#08283f' : state.isFocused ? '#f5f5f5' : 'white',
                                                            color: state.isSelected ? 'white' : '#333333',
                                                            '&:hover': {
                                                                background: state.isSelected ? '#08283f' : '#f5f5f5'
                                                            }
                                                        }),
                                                        multiValue: (base) => ({
                                                            ...base,
                                                            background: '#f0f0f0',
                                                            border: '1px solid #d0d0d0'
                                                        }),
                                                        multiValueLabel: (base) => ({
                                                            ...base,
                                                            color: '#333333'
                                                        }),
                                                        multiValueRemove: (base) => ({
                                                            ...base,
                                                            color: '#9e9e9e',
                                                            '&:hover': {
                                                                background: '#08283f',
                                                                color: 'white'
                                                            }
                                                        }),
                                                        input: (base) => ({
                                                            ...base,
                                                            color: '#333333'
                                                        }),
                                                        placeholder: (base) => ({
                                                            ...base,
                                                            color: '#666666'
                                                        }),
                                                        singleValue: (base) => ({
                                                            ...base,
                                                            color: '#333333'
                                                        })
                                                    }}
                                                />
                                            </div>
                                            <button
                                                type="button"
                                                className="btn btn-primary plusButtonEmail ms-2"
                                                onClick={() => {
                                                    addEmail()
                                                }}
                                            >
                                                <i className="fa fa-plus i_Icon"></i>
                                            </button>
                                        </div>
                                    </div>
                                    <div className="col-md-12">
                                        {emails?.map((m, index) => (
                                            <span key={index} className="emailBox">
                                                {m}
                                                <i
                                                    className="fa fa-times-circle crossEmailButton"
                                                    onClick={() => removeEmail(index)}
                                                ></i>
                                            </span>
                                        ))}
                                    </div>
                                    <div className="col-md-4">
                                        <label className="form-label mb-1" style={{ fontWeight: 300 }}>Due date</label>
                                        <div className="input-group">
                                            <input 
                                                type="date" 
                                                className="form-control border-0 inputUpdateLastest"
                                                onChange={(e) => setDueDate(e.target.value)}
                                                placeholder="22/04/2024" 
                                            />
                                        </div>
                                    </div>
                                </div>

                                <div className="mb-4">
                                    <div className="d-flex align-items-start">
                                        <div className="custom-checkbox-wrapper">
                                            <input 
                                                type="checkbox" 
                                                id="termsCheckbox"
                                                className="custom-checkbox" 
                                                checked={confirm}
                                                onChange={(e) => setConfirm(e.target.checked)}
                                            />
                                            <label 
                                                htmlFor="termsCheckbox" 
                                                className="custom-checkbox-label"
                                            ></label>
                                        </div>
                                        <label 
                                            htmlFor="termsCheckbox"
                                            className="ms-3 terms-text"
                                            style={{ 
                                                fontSize: "13px", 
                                                fontWeight: 400,
                                                color: '#666666',
                                                cursor: 'pointer',
                                                userSelect: 'none'
                                            }}
                                        >
                                            &nbsp;I confirm that I have reviewed and accept the terms and conditions, including the data privacy policy.
                                        </label>
                                    </div>
                                </div>

                                <div className="d-flex align-items-center justify-content-end">
                                    <button 
                                        className="send-button ms-2"
                                        onClick={sendButton}
                                    >
                                        Send
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div
                className={`modal fade Form-Wizard-modal ${isModal === "Form Wizard modal" ? "d-block show" : ""
                    }`}
            >
                <div className="modal-dialog modal-lg" id="clientModal">
                    <div className="modal-content">
                        <div className="modal-header border-none pb-0">
                            <div className="boxAVersion d-flex justify-content-between w-100">
                                <p className="mb-0">{isModalData?.title}</p>
                                <p className="mb-0 mr-10">{isModalData?.version}</p>
                            </div>
                            <button
                                type="button"
                                data-dismiss="modal"
                                aria-label="Close"
                                onClick={() => setModal("")}
                            >
                                <span aria-hidden="true">×</span>
                            </button>
                        </div>
                        <div className="modal-body pricing_page overflow-hidden pt-0">
                            <div className="card">
                                <div className="group-box group-box-template p-0 border-none">
                                    <div>
                                        {isModalData?.questions?.map((category, catIndex) => (
                                            <Accordion key={catIndex} defaultExpanded={catIndex === 0}>
                                                <AccordionSummary
                                                    expandIcon={<ExpandMoreIcon />}
                                                    aria-controls={`panel${catIndex}-content`}
                                                    id={`panel${catIndex}-header`}
                                                >
                                                    {category?.categoryName}
                                                    <span className="boxButton">
                                                        {/* {catIndex + 1} */}
                                                        {category?.categoryQuestions?.length}
                                                    </span>
                                                </AccordionSummary>
                                                {category?.categoryQuestions?.map((question, qIndex) => (
                                                    <AccordionDetails key={qIndex}>
                                                        <div className="boxAccordian">
                                                            <div className="d-flex justify-content-between align-items-center">
                                                                <p>
                                                                    {qIndex + 1}. {question?.question_text}
                                                                </p>
                                                                <img src={humburger} className="img-fluid" alt="Menu" />
                                                            </div>
                                                            {question?.evidence == true && (<>
                                                                    <span className="uploadDoc">
                                                                        Upload Documents
                                                                        <img src={uploadDoc} className="img-fluid" />
                                                                    </span>
                                                                </>)}
                                                                <div className="mb-4">
                                                                    {question?.type === "text" ? (
                                                                        <textarea
                                                                            className="form-control form-control-review border-0 inputUpdateLastest"
                                                                            rows="4"
                                                                            placeholder="Response"
                                                                            disabled
                                                                            value={question?.response?.value}
                                                                        ></textarea>
                                                                    ) : question?.options?.map((option, optIndex) => (
                                                                        <span
                                                                            key={optIndex}
                                                                            className={`form-control w-50 mt-2 mb-3 border-0 inputUpdateLastest ${question?.response?.value?.includes(option)
                                                                                ? "selectedOption"
                                                                                : ""
                                                                                }`}
                                                                        >
                                                                            {option}
                                                                        </span>
                                                                    ))}
                                                                </div>
                                                        </div>
                                                        {question.showComment && (
                                                                        <div className="mt-3">
                                                                            <textarea
                                                                                className="form-control form-control-review border-0 inputUpdateLastest"
                                                                                placeholder="Comment"
                                                                                disabled
                                                                                value={question.comment || ""}
                                                                                row="4"
                                                                            ></textarea>
                                                                        </div>
                                                        )}
                                                    </AccordionDetails>
                                                ))}
                                            </Accordion>
                                        ))}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <style jsx>{`
                .custom-checkbox-wrapper {
                    position: relative;
                    width: 20px;
                    height: 20px;
                    margin-top: 2px;
                }
                .custom-checkbox {
                    position: absolute;
                    opacity: 0;
                    cursor: pointer;
                    height: 0;
                    width: 0;
                }
                .custom-checkbox-label {
                    position: absolute;
                    top: 0;
                    left: 0;
                    height: 20px;
                    width: 20px;
                    background-color: white;
                    border: 2px solid #08283f;
                    border-radius: 4px;
                    cursor: pointer;
                }
                .custom-checkbox-label:after {
                    content: "";
                    position: absolute;
                    display: none;
                    left: 6px;
                    top: 2px;
                    width: 5px;
                    height: 10px;
                    border: solid white;
                    border-width: 0 2px 2px 0;
                    transform: rotate(45deg);
                }
                .custom-checkbox:checked ~ .custom-checkbox-label {
                    background-color: #08283f;
                    border-color: #08283f;
                }
                .custom-checkbox:checked ~ .custom-checkbox-label:after {
                    display: block;
                }
                .custom-checkbox-label:hover {
                    border-color: #08283f;
                }
                .terms-text:hover {
                    color: #08283f;
                }
            `}</style>
        </div>

    );
};

export default SendQuestionnaires;
